import { PROJECTS_STATE_LOCAL_STORAGE_KEY, PROJECTS_REDUCER_NAME } from './Constants';

import { useProjectList, useProjectByProjectId } from './Selector';
import projectsReducer, { setProjects, deleteProjectById } from './Reducer';
import { saveProjectsInLocalStorage } from './Middleware';
import { removeProjectsInLocalStorage } from './ProjectsController';

export {
  PROJECTS_STATE_LOCAL_STORAGE_KEY,
  PROJECTS_REDUCER_NAME,
  useProjectList,
  useProjectByProjectId,
  setProjects,
  deleteProjectById,
  saveProjectsInLocalStorage,
  removeProjectsInLocalStorage,
};

export default projectsReducer;
